import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

import {FEATURE_FLAGS} from '/DevFeatureFlags';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.closeToFibc');

  return (
    <View>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{tt('title', 'Close To FIBC')}</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('orderingEntities', 'Ordering Entities')}</Text>}
          suffix={<LoadingBox style={styles.loadingBox} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('seniorCoachTeams', 'Senior Coach Teams')}</Text>}
          suffix={<LoadingBox style={styles.loadingBox} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('gqv', 'Group Qualifying Volume')}</Text>}
          suffix={<LoadingBox style={styles.loadingBox} />}
        />
      </Gutter>
      {FEATURE_FLAGS.showCertificationReference && (
        <Gutter>
          <ListItem
            style={{base: styles.listItem}}
            readonly={true}
            label={<Text>{tt('certified', 'Be Certified')}</Text>}
          />
        </Gutter>
      )}
    </View>
  );
};
